// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var NodeType;
(function (NodeType) {
    NodeType["NODE_TYPE_UNSPECIFIED"] = "NODE_TYPE_UNSPECIFIED";
    NodeType["NODE_TYPE_START"] = "NODE_TYPE_START";
    NodeType["NODE_TYPE_BOOLEAN"] = "NODE_TYPE_BOOLEAN";
    NodeType["NODE_TYPE_FORWARD_DEVICE"] = "NODE_TYPE_FORWARD_DEVICE";
    NodeType["NODE_TYPE_FORWARD_NUMBER"] = "NODE_TYPE_FORWARD_NUMBER";
    NodeType["NODE_TYPE_VOICEMAIL_BOX"] = "NODE_TYPE_VOICEMAIL_BOX";
    NodeType["NODE_TYPE_TERMINATE"] = "NODE_TYPE_TERMINATE";
    NodeType["NODE_TYPE_CALL_GROUP"] = "NODE_TYPE_CALL_GROUP";
    NodeType["NODE_TYPE_CALL_QUEUE"] = "NODE_TYPE_CALL_QUEUE";
    NodeType["NODE_TYPE_CALL_ROUTE"] = "NODE_TYPE_CALL_ROUTE";
    NodeType["NODE_TYPE_PHONE_TREE"] = "NODE_TYPE_PHONE_TREE";
    NodeType["NODE_TYPE_PLAY_MESSAGE"] = "NODE_TYPE_PLAY_MESSAGE";
    NodeType["NODE_TYPE_PHONE_HOURS"] = "NODE_TYPE_PHONE_HOURS";
    NodeType["NODE_TYPE_OPEN_HOURS"] = "NODE_TYPE_OPEN_HOURS";
    NodeType["NODE_TYPE_CLOSED_HOURS"] = "NODE_TYPE_CLOSED_HOURS";
    NodeType["NODE_TYPE_BREAK_HOURS"] = "NODE_TYPE_BREAK_HOURS";
    NodeType["NODE_TYPE_REPEAT"] = "NODE_TYPE_REPEAT";
    NodeType["NODE_TYPE_FALLBACK"] = "NODE_TYPE_FALLBACK";
    NodeType["NODE_TYPE_TREE_OPTION"] = "NODE_TYPE_TREE_OPTION";
})(NodeType || (NodeType = {}));
export var NodeType_index;
(function (NodeType_index) {
    NodeType_index[NodeType_index["NODE_TYPE_UNSPECIFIED"] = 0] = "NODE_TYPE_UNSPECIFIED";
    NodeType_index[NodeType_index["NODE_TYPE_START"] = 1] = "NODE_TYPE_START";
    NodeType_index[NodeType_index["NODE_TYPE_BOOLEAN"] = 2] = "NODE_TYPE_BOOLEAN";
    NodeType_index[NodeType_index["NODE_TYPE_FORWARD_DEVICE"] = 3] = "NODE_TYPE_FORWARD_DEVICE";
    NodeType_index[NodeType_index["NODE_TYPE_FORWARD_NUMBER"] = 4] = "NODE_TYPE_FORWARD_NUMBER";
    NodeType_index[NodeType_index["NODE_TYPE_VOICEMAIL_BOX"] = 5] = "NODE_TYPE_VOICEMAIL_BOX";
    NodeType_index[NodeType_index["NODE_TYPE_TERMINATE"] = 6] = "NODE_TYPE_TERMINATE";
    NodeType_index[NodeType_index["NODE_TYPE_CALL_GROUP"] = 7] = "NODE_TYPE_CALL_GROUP";
    NodeType_index[NodeType_index["NODE_TYPE_CALL_QUEUE"] = 8] = "NODE_TYPE_CALL_QUEUE";
    NodeType_index[NodeType_index["NODE_TYPE_CALL_ROUTE"] = 9] = "NODE_TYPE_CALL_ROUTE";
    NodeType_index[NodeType_index["NODE_TYPE_PHONE_TREE"] = 10] = "NODE_TYPE_PHONE_TREE";
    NodeType_index[NodeType_index["NODE_TYPE_PLAY_MESSAGE"] = 11] = "NODE_TYPE_PLAY_MESSAGE";
    NodeType_index[NodeType_index["NODE_TYPE_PHONE_HOURS"] = 12] = "NODE_TYPE_PHONE_HOURS";
    NodeType_index[NodeType_index["NODE_TYPE_OPEN_HOURS"] = 13] = "NODE_TYPE_OPEN_HOURS";
    NodeType_index[NodeType_index["NODE_TYPE_CLOSED_HOURS"] = 14] = "NODE_TYPE_CLOSED_HOURS";
    NodeType_index[NodeType_index["NODE_TYPE_BREAK_HOURS"] = 15] = "NODE_TYPE_BREAK_HOURS";
    NodeType_index[NodeType_index["NODE_TYPE_REPEAT"] = 16] = "NODE_TYPE_REPEAT";
    NodeType_index[NodeType_index["NODE_TYPE_FALLBACK"] = 17] = "NODE_TYPE_FALLBACK";
    NodeType_index[NodeType_index["NODE_TYPE_TREE_OPTION"] = 18] = "NODE_TYPE_TREE_OPTION";
})(NodeType_index || (NodeType_index = {}));
export var CallRouteType;
(function (CallRouteType) {
    CallRouteType["CALL_ROUTE_TYPE_UNSPECIFIED"] = "CALL_ROUTE_TYPE_UNSPECIFIED";
    CallRouteType["CALL_ROUTE_TYPE_CALL_ROUTE"] = "CALL_ROUTE_TYPE_CALL_ROUTE";
    CallRouteType["CALL_ROUTE_TYPE_DEPARTMENT"] = "CALL_ROUTE_TYPE_DEPARTMENT";
    CallRouteType["CALL_ROUTE_TYPE_EXTENSION"] = "CALL_ROUTE_TYPE_EXTENSION";
})(CallRouteType || (CallRouteType = {}));
export var CallRouteType_index;
(function (CallRouteType_index) {
    CallRouteType_index[CallRouteType_index["CALL_ROUTE_TYPE_UNSPECIFIED"] = 0] = "CALL_ROUTE_TYPE_UNSPECIFIED";
    CallRouteType_index[CallRouteType_index["CALL_ROUTE_TYPE_CALL_ROUTE"] = 1] = "CALL_ROUTE_TYPE_CALL_ROUTE";
    CallRouteType_index[CallRouteType_index["CALL_ROUTE_TYPE_DEPARTMENT"] = 2] = "CALL_ROUTE_TYPE_DEPARTMENT";
    CallRouteType_index[CallRouteType_index["CALL_ROUTE_TYPE_EXTENSION"] = 3] = "CALL_ROUTE_TYPE_EXTENSION";
})(CallRouteType_index || (CallRouteType_index = {}));
export var ScheduleType;
(function (ScheduleType) {
    ScheduleType["UNSPECIFIED"] = "UNSPECIFIED";
    ScheduleType["OPEN"] = "OPEN";
    ScheduleType["BREAK"] = "BREAK";
})(ScheduleType || (ScheduleType = {}));
export var ScheduleType_index;
(function (ScheduleType_index) {
    ScheduleType_index[ScheduleType_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    ScheduleType_index[ScheduleType_index["OPEN"] = 1] = "OPEN";
    ScheduleType_index[ScheduleType_index["BREAK"] = 2] = "BREAK";
})(ScheduleType_index || (ScheduleType_index = {}));
export var VoicemailGreetingType_Enum;
(function (VoicemailGreetingType_Enum) {
    VoicemailGreetingType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    VoicemailGreetingType_Enum["NO_GREETING"] = "NO_GREETING";
    VoicemailGreetingType_Enum["DEFAULT_GREETING"] = "DEFAULT_GREETING";
    VoicemailGreetingType_Enum["NUMBERED_GREETING"] = "NUMBERED_GREETING";
    VoicemailGreetingType_Enum["AUDIO_LIBRARY_GREETING"] = "AUDIO_LIBRARY_GREETING";
})(VoicemailGreetingType_Enum || (VoicemailGreetingType_Enum = {}));
export var VoicemailGreetingType_Enum_index;
(function (VoicemailGreetingType_Enum_index) {
    VoicemailGreetingType_Enum_index[VoicemailGreetingType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    VoicemailGreetingType_Enum_index[VoicemailGreetingType_Enum_index["NO_GREETING"] = 1] = "NO_GREETING";
    VoicemailGreetingType_Enum_index[VoicemailGreetingType_Enum_index["DEFAULT_GREETING"] = 2] = "DEFAULT_GREETING";
    VoicemailGreetingType_Enum_index[VoicemailGreetingType_Enum_index["NUMBERED_GREETING"] = 3] = "NUMBERED_GREETING";
    VoicemailGreetingType_Enum_index[VoicemailGreetingType_Enum_index["AUDIO_LIBRARY_GREETING"] = 4] = "AUDIO_LIBRARY_GREETING";
})(VoicemailGreetingType_Enum_index || (VoicemailGreetingType_Enum_index = {}));
export const CallRouteService = {
    /**
     * Create a Call Route
     */
    Create(fn, req) {
        return fn(`/phone/callroute/v1`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Update the call route name and location_id
     */
    Update(fn, req) {
        try {
            fm.validateUrlParam(req["callRouteId"], "callRouteId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callroute/v1/${req["callRouteId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Read a Call Route by call route id or instruction set id.
     */
    Read(fn, req) {
        try {
            fm.validateUrlParam(req["callRouteId"], "callRouteId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callroute/v1/${req["callRouteId"]}?${fm.renderURLSearchParams(req, ["callRouteId"])}`, { method: "GET" });
    },
    /**
     * List Call Routes belonging to the tenant
     */
    List(fn, req) {
        return fn(`/phone/callroute/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Save a Call Graph.
     */
    Save(fn, req) {
        return fn(`/phone/callroute/v1/save`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Delete a Call Route
     */
    Delete(fn, req) {
        try {
            fm.validateUrlParam(req["callRouteId"], "callRouteId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callroute/v1/${req["callRouteId"]}?${fm.renderURLSearchParams(req, ["callRouteId"])}`, { method: "DELETE" });
    },
    /**
     * UpdatePhoneNumbers assigns the given phone numbers to the Call Route.
     * In PDS, it will update the Phone Number's InstructionSet.
     * This is a replace operation. Numbers omitted will be removed.
     * Removing a phone number from a Call Route will unassign the InstructionSet from the Phone Number.
     */
    UpdatePhoneNumbers(fn, req) {
        try {
            fm.validateUrlParam(req["callRouteId"], "callRouteId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callroute/v1/${req["callRouteId"]}/phone_numbers`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * UpdateExtensions assigns the given extensions to the Call Route.
     * This is a replace operation. Extensions omitted will be removed.
     * Removing an extension from a Call Route will unassign the Extension's InstructionSet.
     * The 7000 ext range is reserved for Call Routes.
     * Other ranges are possible through PDS and historical data.
     */
    UpdateExtensions(fn, req) {
        try {
            fm.validateUrlParam(req["callRouteId"], "callRouteId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callroute/v1/${req["callRouteId"]}/extensions`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * PromoteToCallRoute is an idempotent operation that creates a Call Route from an InstructionSet.
     * Requires the InstructionSet to exist in PDS.
     */
    PromoteToCallRoute(fn, req) {
        return fn(`/phone/callroute/v1/promote_call_route`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * List Phone Hours by location and any associated call route
     */
    ListPhoneHours(fn, req) {
        return fn(`/phone/callroute/v1/hours?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     *Read Phone Hours returns the associated schedules for the specified phone hour id
     */
    ReadPhoneHours(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callroute/v1/hours/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    /**
     * Generate a Call Graph for an existing Call Route.
     * This generates the json of the graph. Does not save to the DB.
     */
    Generate(fn, req) {
        return fn(`/phone/callroute/v1/generate?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Sync generates the call graph json and saves it to the DB.
     */
    Sync(fn, req) {
        return fn(`/phone/callroute/v1/sync`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *Update Phone Hours lets the user change the schedule phone Hours
     *A user is not able to create a new schedule, only update existing schedules
     */
    UpdatePhoneHour(fn, req) {
        return fn(`/phone/callroute/v1/hours`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
};
